import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SortedSet, UserWithEmplId } from '../../domain';

export interface SelectUserModalData {
	title?: string;
	excludeIds?: number[];
}

/** Single-user picker backed by the local PB user table rather than the ANR
 *  directory, so filtering happens in the browser and callers can exclude
 *  people who are already on the committee. */
@Component({
	templateUrl: './select-user-modal.component.html'
})
export class SelectUserModalComponent {
	form: FormGroup;
	title: string;
	excludeIds: number[];
	selectedUserId: number | null = null;

	constructor(
		@Inject(MAT_DIALOG_DATA) data: SelectUserModalData,
		fb: FormBuilder,
		private readonly dialogRef: MatDialogRef<SelectUserModalComponent>
	) {
		this.title = data?.title || 'Select a Person';
		this.excludeIds = data?.excludeIds || [];
		this.form = fb.group({
			'user': new SortedSet<UserWithEmplId>([])
		});
		this.form.controls['user'].valueChanges
			.pipe(map(v => <SortedSet<UserWithEmplId>>v))
			.subscribe(users => {
				const first = users.toArray()[0];
				this.selectedUserId = first ? first.id : null;
			});
	}

	/** Resolves to the chosen user's ID, or null if the dialog was dismissed. */
	public static open(dialog: MatDialog, data?: SelectUserModalData): Observable<null | number> {
		return dialog.open(SelectUserModalComponent, {
			width: '600px',
			disableClose: false,
			data: data || {},
			hasBackdrop: true
		})
			.afterClosed()
			.pipe(map(result => {
				const userId = parseInt(result);
				return isNaN(userId) ? null : userId;
			}));
	}

	save() {
		this.dialogRef.close(this.selectedUserId);
	}

	cancel() {
		this.dialogRef.close();
	}
}
